/**
 * Created by RKL on 13/08/2015.
 */
define('kitProtDetailView',[
  'module',
  'kitProtCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!kitProtDetailTabTpl'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl
) {
  'use strict';

  var KitProtDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    onShow: function() {
      $.material.init();
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.viewLess = this.model.get('secId');
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        kitProtModel: this.model
      });
      createEditView.show({
        title: _.i18n('kitprot.edit')
      });
    }

  });

  module.exports = KitProtDetailView;
});
